define.alias("@ember/render-modifiers/modifiers/will-destroy", "settings/modifiers/will-destroy");